export const getHome = () => window.location.origin;
